export class FoodTypeModel {
    item_no: number
    item_desc: string

    constructor(
        item_no: number,
        item_desc: string
    ) {
        this.item_no = item_no
        this.item_desc = item_desc
    }
}